import React from 'react';
import { Modal } from '@mantine/core';
import { ONTOPO_METHOD_LABELS, ONTOPO_STATUS_LABELS } from '../monitoring-page.constants';
import { formatDateTime } from '../monitoring-page.utils';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type OntopoCallLogDetailModalProps = Pick<UseMonitoringPage, 'selectedOntopoLog' | 'closeOntopoDetail'>;

const prettyJson = (value: string | null): string => {
  if (!value) {
    return '—';
  }
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

export const OntopoCallLogDetailModal: React.FC<OntopoCallLogDetailModalProps> = ({
  selectedOntopoLog,
  closeOntopoDetail,
}) => {
  const row = selectedOntopoLog;

  const fields: { label: string; value: string }[] = row
    ? [
        { label: 'תאריך ושעה', value: formatDateTime(row.createdAt) },
        { label: 'עסק', value: row.companyName ?? row.tenantId ?? '-' },
        { label: 'פעילות', value: ONTOPO_METHOD_LABELS[row.method] ?? row.method },
        { label: 'כיוון', value: row.direction === 'inbound' ? 'נכנס' : 'יוצא' },
        { label: 'סטטוס', value: ONTOPO_STATUS_LABELS[row.status] ?? row.status },
        { label: 'קוד HTTP', value: row.httpStatus != null ? String(row.httpStatus) : '-' },
        { label: 'זמן תגובה', value: row.latencyMs != null ? `${row.latencyMs} ms` : '-' },
        { label: 'ניסיון', value: String(row.attempt) },
        { label: 'הזמנה', value: row.orderReference ?? (row.orderId != null ? String(row.orderId) : '-') },
        { label: 'שולחן', value: row.tableName ?? '-' },
        { label: 'יעד', value: row.endpoint },
      ]
    : [];

  return (
    <Modal
      opened={row != null}
      onClose={closeOntopoDetail}
      title={row ? `${ONTOPO_METHOD_LABELS[row.method] ?? row.method} · ${ONTOPO_STATUS_LABELS[row.status] ?? row.status}` : ''}
      centered
      size="xl"
      closeButtonProps={{ 'data-testid': 'monitoring-ontopo-detail-close' } as Record<string, string>}
    >
      {row && (
        <div className={classes.errorDetail} data-testid="monitoring-ontopo-detail">
          <div className={classes.detailsSection}>
            {fields.map((field) => (
              <div key={field.label} className={classes.detailField}>
                <span className={classes.detailLabel}>{field.label}</span>
                <span className={classes.detailValue}>{field.value}</span>
              </div>
            ))}
          </div>

          {row.errorMessage && (
            <>
              <div className={classes.sectionTitle}>{'שגיאה'}</div>
              <pre className={classes.errorTrace}>{row.errorMessage}</pre>
            </>
          )}

          <div className={classes.sectionTitle}>{'בקשה'}</div>
          <pre className={classes.errorTrace}>{prettyJson(row.requestPayload)}</pre>

          <div className={classes.sectionTitle}>{'תגובה'}</div>
          <pre className={classes.errorTrace}>{prettyJson(row.responseBody)}</pre>
        </div>
      )}
    </Modal>
  );
};
